import { FETCH_INSTITUTION_ASSOCIATED_PROVIDERS_DATA } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(FETCH_INSTITUTION_ASSOCIATED_PROVIDERS_DATA);
export default reducer;
